export const resetStyle = `
    /**
     * Change from box-sizing: content-box so that width is not affected by padding or border.
     */
    *,
    *::before,
    *::after {
        box-sizing: border-box; /* 1 */
    }

    /**
     * Remove input clear cross in IE
     */
    ::-ms-clear {
        display: none;
    }

    menu,
    ul,
    ol,
    p,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    blockquote,
    legend,
    fieldset,
    button {
        margin: 0;
        padding: 0;
    }

    /**
     * Reset button styles.
     * It takes a bit of work to achieve a neutral look.
     */
    button {
        border: none;
        font: inherit;
        color: inherit;
        background-color: transparent;
        cursor: pointer;
        outline: none;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
    }

    /**
     * Links
     */
    a {
        color: inherit;
        text-decoration: none;
    }

    ul,
    ol,
    menu {
        list-style: none;
    }

    ins {
        text-decoration: none;
    }

    fieldset {
        border: none;
        min-inline-size: min-content;
    }
`;
